import Image, { ImageLoaderProps, ImageProps } from 'next/image'
import imageUrlBuilder from '@sanity/image-url'
import sanity from '../lib/sanity'

interface SanityImageProps extends ImageProps {
  width: number
  height: number
}

const SanityImage = (props: SanityImageProps) => {
  const builder = imageUrlBuilder(sanity)

  const imageProps = {
    ...props,
    loader: ({ src, width, quality }: ImageLoaderProps) =>
      builder
        .image(src)
        .width(width)
        .quality(quality || 75)
        .url(),
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image {...imageProps} />
}

export default SanityImage
